import { ValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/validation-message-resolver';
import { TranslateService } from '@ngx-translate/core';
import { Injectable, inject } from '@angular/core';
import { DIVISIBLE_BY_VALIDATOR_NAME } from '@iris/common/modules/fields/validation/validators/divisible-by.validator';

@Injectable()
export class DivisibleByValidationMessageResolver implements ValidationMessageResolver {
  private readonly translateService = inject(TranslateService);

  readonly errorCode = DIVISIBLE_BY_VALIDATOR_NAME;

  getMessage(error?: { step: number }): string {
    return this.translateService.instant('label.validation.divisibleBy', { step: error?.step });
  }
}
